import React, { useCallback, memo } from 'react';
import * as Styled from './styled';
import { TableCell } from '@leasequery/lq.react-component-library/dist/components/table';
import { ArchivedReport } from '../../../models';
import { Icon } from '../../../components';

interface DeleteButtonCellProps {
  cell: TableCell;
  onClick: (archivedReport: ArchivedReport) => void;
}

function DeleteButtonCell({
  cell,
  onClick,
}: DeleteButtonCellProps): JSX.Element {
  const rowData = cell.row.original as ArchivedReport;
  const clickHandler = useCallback(() => {
    onClick(rowData);
  }, [onClick, rowData]);

  return (
    <Styled.DeleteButtonCell onClick={clickHandler}>
      <Icon name="trash" />
    </Styled.DeleteButtonCell>
  );
}

export default memo(DeleteButtonCell);
